import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const aurorasit: IPartnerAppSettings = {
  // Flighting call does not support AuroraSit currently. Fallback to Sit
  flightingAppEnvironment: 'Sit',
  esxpBaseUrl: 'https://esxp-aurora-sit.microsoft.com/',
  cdnBaseUrl: 'https://gcmra-ui-aurorasit.azureedge.net',
  serviceEndPoints: [
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net',
    },
    {
      clientId: '5eb170f9-f828-4121-936c-288eb43b050e',
      serviceEndPoint:
        'https://professionalservicesint.microsoft.com/Time2-SIT',
    },
    {
      clientId: '6f40053e-5319-40e5-a90b-6f714506d96d',
      serviceEndPoint: 'https://esxp-aurora-sit.microsoft.com/rmavl',
    },
    {
      clientId: '38578c27-d821-45d3-95db-fcf0e8371e68',
      serviceEndPoint: 'https://grmetoeapiwus.azurewebsites.net',
    },
    {
      clientId: '6f40053e-5319-40e5-a90b-6f714506d96d',
      serviceEndPoint: 'https://maintenancebackgroundfunction-uat-wus.azurewebsites.net',
    },
    {
      clientId: 'c5779b49-c238-45cb-8974-36958d4c7d96',
      serviceEndPoint: 'https://pslakedsdev.azurewebsites.net',
    }
  ],
  OneProfileBaseUrl: 'https://oneprofileuatapipack.azurefd.net',
  TimeCoreBaseUrl: 'https://professionalservicesint.microsoft.com/Time2-SIT',
  TimeSubscriptionKey: 'b7f08ad447dd45f490a0f812eaef7bfc',
  AvailabilityBaseUrl: 'https://esxp-aurora-sit.microsoft.com/rmavl',
  UpdateAutomatedForecastUrl: 'https://maintenancebackgroundfunction-uat-wus.azurewebsites.net',
  GrmApiBaseUrl: 'https://grmetoeapiwus.azurewebsites.net',
  GrmAzureSearchUrl: 'https://esxp-sit.microsoft.com',
  PsdlISDForecastBaseUrl :'https://pslakedsdev.azurewebsites.net',
  ProjectDetailsEndUrl:
    '/api/v1/Search/grmaurorasit/grm-assignmentsearch-aurorasit-index',
  EmailNotificationBaseUrl: '',
  TimeAssetsUrl: 'https://LMT-AFD-ENDPOINT-DEV-f4g0gngpg0cucqgt.b02.azurefd.net/assets/',
  OpGraphQlUrl: 'https://preprod.apis.profileskills.microsoft.com/graphql',
  RMResourceForecast: {
    NonProjectEventPriority: [35, 22, 16, 13, 33, 21, 37, 11, 4, 17],
    ClarityCode: '',
  },
  RMExperience: {
    batchSize: 10,
    numAvAPIParallelCalls: 2,
    RMPageSize: 100,
    isCosmosEndpoint: true,
  },
};
